import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  interface Image {
    id?: string;
    _id?: string;
    name: string;
    mainImage?: string;
    url?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseSelectorDesktop',
  props: {
    images: {},
    selectedimage: {},
    isSelectDesign: { type: Boolean },
    isSelectFacade: { type: Boolean }
  },
  emits: ["onRequestQuote", "onSelectImage", "onSelectHouse"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const { isDesktop } = useIsDesktop(990);

  const displayedImages = ref<Image[]>([...props.images]);
  const builderCarousel = ref<HTMLElement>();

  const containerClasses = computed(() => ({
    "select-design": props.isSelectDesign,
    "select-facade": props.isSelectFacade,
  }));

  const getImageKey = (image: Image, index: number): string | number =>
    image.id || image._id || index;

  const getImageSource = (image: Image): string =>
    image.mainImage || image.url || "";

  const getImageClasses = (image: Image) => ({
    checkmark: props.isSelectDesign
      ? props.selectedimage?._id === image._id
      : props.selectedimage?.id === image.id,
    "select-facade": props.isSelectFacade,
  });

  const handleImageSelection = (image: Image) => {
    const selectedId = props.isSelectDesign ? image._id : image.id;
    const currentId = props.isSelectDesign
      ? props.selectedimage?._id
      : props.selectedimage?.id;

    if (selectedId === currentId) return;

    emits("onSelectImage", selectedId);
  };

  const handleScroll = () => {
    if (!builderCarousel.value) return;

    const { clientWidth, scrollLeft, scrollWidth } = builderCarousel.value;
    const maxScroll = scrollWidth - clientWidth;
    const tolerance = 20;

    if (maxScroll - scrollLeft < clientWidth / 2 + tolerance) {
      displayedImages.value = [...displayedImages.value, ...props.images];
    }
  };

  watch(
    () => props.images,
    (newImages) => {
      displayedImages.value = newImages;
    }
  );

const __returned__ = { props, emits, isDesktop, displayedImages, builderCarousel, containerClasses, getImageKey, getImageSource, getImageClasses, handleImageSelection, handleScroll, computed, ref, watch, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})